export default __webpack_public_path__ + "static/media/title_zh_tw_pc@2x.a3b8a81d.png";